import { Button, Tooltip } from '@mui/material'
import React from 'react'
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend'
import { useAutoMailModal } from 'utils/hooks'
import { useCompanies } from 'contexts'

const AutoMailButton = () => {
  const { setOpenModal, AutoMailModal } = useAutoMailModal()
  const { validatedSelectionState } = useCompanies()

  const handleClick = () => {
    setOpenModal(true)
  }

  const hasSingleSelection = validatedSelectionState.mode === 'single'
  const isAllAccountsSelection = validatedSelectionState.mode === 'allAccounts'

  if (!hasSingleSelection || isAllAccountsSelection) {
    return null
  }

  return (
    <>
      <Tooltip
        title="Envoi de mail auto..."
        followCursor
      >
        <Button
          type="button"
          onClick={handleClick}
          //   disabled={isPending}
          className="text-white"
        >
          <ScheduleSendIcon className="text-white" />
        </Button>
      </Tooltip>
      <AutoMailModal />
    </>
  )
}

export default AutoMailButton
